/**
 * Reorders merchant-managed size-guide page content for the PDP modal.
 * Measurement tables appear first, followed by measuring instructions and notes.
 */
function enhanceSizeChartModal() {
  const content = document.querySelector('[data-size-chart-content]');
  if (!content || content.dataset.enhanced === 'true') return;

  const children = Array.from(content.children);
  const consumed = new Set();
  const measurements = document.createElement('div');
  measurements.className = 'size-chart-modal__measurements';

  const previousContentElement = (element) => {
    let anchor = element;

    while (anchor && anchor !== content) {
      let candidate = anchor.previousElementSibling;

      while (candidate) {
        if (candidate.textContent.trim() || candidate.querySelector('img, video, iframe')) return candidate;
        candidate = candidate.previousElementSibling;
      }

      anchor = anchor.parentElement;
    }

    return null;
  };

  Array.from(content.querySelectorAll('table')).forEach((table) => {
    const group = document.createElement('section');
    group.className = 'size-chart-modal__table-group';

    const heading = previousContentElement(table);
    if (heading && ['P', 'H2', 'H3', 'H4'].includes(heading.tagName)) {
      heading.classList.add('size-chart-modal__table-heading');
      group.appendChild(heading);
      consumed.add(heading);
    }

    group.appendChild(table);
    consumed.add(table);
    measurements.appendChild(group);
  });

  const howToList = content.querySelector('ul');
  const illustration = content.querySelector('[data-size-chart-illustration]');
  const howTo = document.createElement('section');
  howTo.className = 'size-chart-modal__how-to';

  if (howToList) {
    const heading = previousContentElement(howToList);
    if (heading && ['P', 'H2', 'H3', 'H4'].includes(heading.tagName)) {
      heading.classList.add('size-chart-modal__how-to-heading');
      howTo.appendChild(heading);
      consumed.add(heading);
    }

    howTo.appendChild(howToList);
    consumed.add(howToList);
  }

  if (illustration) {
    howTo.appendChild(illustration);
    consumed.add(illustration);
  }

  const notes = document.createElement('div');
  notes.className = 'size-chart-modal__notes';

  children.forEach((element) => {
    if (consumed.has(element)) return;
    if (!element.textContent.trim() && !element.querySelector('img, video, iframe')) return;
    notes.appendChild(element);
  });

  content.replaceChildren();
  if (measurements.children.length) content.appendChild(measurements);
  if (howTo.children.length) content.appendChild(howTo);
  if (notes.children.length) content.appendChild(notes);
  content.dataset.enhanced = 'true';
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceSizeChartModal, { once: true });
} else {
  enhanceSizeChartModal();
}
